module.exports = __webpack_public_path__ + "static/felipe-5caedffdb950bfec8f081974d9b8f2dd.jpg";